import Link from "next/link";
import React from "react";
import Head from "next/head";

import classes from "@/styles/blog/blog-main.module.css";
import ArticleContent from "@/components/blog/article-content";
import { ArticleType } from "@/@types/BlogArticle";
import { routes } from "@/utils/routes";
import { blogArticle as blogArticleContent, common } from "@/utils/content";
import { MdArrowBackIos } from "react-icons/md";

type ArticlesProps = {
  blogArticle: ArticleType;
};

const Article = ({ blogArticle }: ArticlesProps) => {
  const content = blogArticleContent.en;
  const commonContent = common.en;

  return (
    <>
      <main>
        <section>
          <div className={`container ${classes.blogDetailsHeader}`}>
            <div>
              <Link
                className="text-secondary d-flex mt-4 fw-bold align-items-center"
                href={routes.blog}
              >
                <MdArrowBackIos />
                <span>{commonContent.btnGoBack}</span>
              </Link>
              <h3 className="mt-4 text-secondary">{content.title}</h3>
            </div>
          </div>
        </section>
        {blogArticle ? (
          <>
            <Head>
              <meta charSet="utf-8" />
              <title>{blogArticle.title}</title>
              <link rel="canonical" href={blogArticle.link} />
              <meta name="description" content={blogArticle.blogDescription} />
              <meta
                name="keywords"
                content={blogArticle.blogKeywords?.join(", ")}
              />
              <meta name="twitter:card" content={blogArticle.id} />
              <meta name="twitter:image" content={blogArticle.localImageURL} />
              <meta name="twitter:title" content={blogArticle.title} />
              <meta name="twitter:creator" content="@shipvista" />
              <meta name="twitter:site" content="@shipvista" />
              <meta
                name="twitter:description"
                content={blogArticle.blogDescription}
              />
              <meta property="og:type" content="website" />
              <meta property="og:url" content="www.shipvista.com" />
              <meta property="og:title" content={blogArticle.title} />
              <meta
                property="og:description"
                content={blogArticle.blogDescription}
              />
              <meta property="og:image" content={blogArticle.localImageURL} />
            </Head>
            <ArticleContent
              classes={classes}
              article={{
                title: blogArticle.title,
                imagePath: blogArticle.localImageURL
                  ? blogArticle.localImageURL
                  : "/images/newsroom/image-na-card.png",
                date: blogArticle.date,
                content: blogArticle.content,
                author: "ShipVista",
                images: blogArticle.images,
                youtubeURL: blogArticle.youtubeURL,
                link: "",
                tags: [],
                id: "0",
              }}
              isBlogPage
            />
          </>
        ) : (
          <section>
            <div className={`container`}>
              <h5>{content.notFound}</h5>
            </div>
          </section>
        )}
      </main>
    </>
  );
};

export default Article;
